export const isUndefinedOrNull = value => value === undefined || value === null
export const isNotUndefinedAndNotNull = value => value !== undefined && value !== null
